import React, { FC } from "react";

type colorList = "red" | "gray";

interface HeatIconProps extends React.HTMLProps<SVGElement> {
  viewBox?: string;
  width?: string;
  height?: string;
  style?: React.CSSProperties;
  color?: colorList;
}

const colorMap = new Map<colorList, { rect: string; path: string }>([
  ["red", { rect: "#F8EAE7", path: "#D5562E" }],
  ["gray", { rect: "#dfe6e9", path: "#636e72" }],
]);

export const HeatIcon: FC<HeatIconProps> = ({
  viewBox,
  width,
  height,
  style,
  color,
}) => {
  const colorItem = colorMap.get(color ?? "red");

  return (
    <svg
      width={width ?? "40"}
      height={height ?? "40"}
      viewBox={viewBox ?? "0 0 40 40"}
      style={style}
    >
      <rect width={"40"} height={"40"} rx="20" fill={colorItem?.rect} />
      <path
        d="M19.1566 29.8246C21.1183 28.7334 24.9183 25.8077 22.7048 19.1659C21.3152 14.9971 21.628 12.2424 21.9829 10.8002C21.9903 10.7702 21.9979 10.7411 22.0054 10.7126L22.0054 10.7126C22.0652 10.4847 22.1134 10.3013 21.9163 10.0871C21.6946 9.84609 21.256 10.1817 21.256 10.1817C19.2628 11.2536 15.5513 14.2218 17.7493 20.8174C19.2363 25.2783 18.8033 28.1266 18.3908 29.4652C18.3908 29.4652 18.2821 29.7786 18.4412 29.9231C18.6002 30.0677 18.8532 29.9933 19.1566 29.8246ZM25.4326 27.0291C26.8362 26.2484 29.555 24.1552 27.9713 19.4032C26.9771 16.4206 27.2009 14.4497 27.4548 13.4179C27.4601 13.3964 27.4655 13.3756 27.4709 13.3552C27.5137 13.1922 27.5481 13.061 27.4071 12.9077C27.2485 12.7352 26.9347 12.9754 26.9347 12.9754C25.5087 13.7422 22.8532 15.8659 24.4258 20.5848C25.4897 23.7764 25.1799 25.8142 24.8848 26.772C24.8848 26.772 24.807 26.9962 24.9208 27.0996C25.0346 27.2031 25.2156 27.1498 25.4326 27.0291ZM16.0277 19.4032C17.6114 24.1552 14.8926 26.2484 13.4891 27.0291C13.2721 27.1498 13.091 27.2031 12.9772 27.0996C12.8635 26.9962 12.9412 26.772 12.9412 26.772C13.2364 25.8142 13.5462 23.7764 12.4823 20.5848C10.9096 15.8659 13.5651 13.7422 14.9912 12.9754C14.9912 12.9754 15.3049 12.7352 15.4636 12.9077C15.6046 13.061 15.5701 13.1922 15.5273 13.3552C15.522 13.3756 15.5165 13.3964 15.5112 13.4179C15.2573 14.4497 15.0335 16.4206 16.0277 19.4032Z"
        fill={colorItem?.path}
      />
    </svg>
  );
};
